// File: frontend/src/components/GDPRConsent/PolicyContents/PrivacyPolicyContent.js

import React from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import styles from './PolicyContent.module.css';

const PrivacyPolicyContent = () => {
  const { t } = useLanguage();

  return (
    <div className={styles.policyContainer}>
      <h1>{t('privacy_policy_title', 'Privacy Policy')}</h1>
      <p className={styles.lastUpdated}>{t('privacy_policy_last_updated', 'Last Updated: January 1, 2023')}</p>
      <p className={styles.effectiveDate}>{t('privacy_policy_effective_date', 'Effective Date: January 15, 2023')}</p>

      <section className={styles.section}>
        <p>{t('privacy_policy.introduction', 'This Privacy Policy describes how we collect, use, and disclose your personal information when you use our services, including our website and applications.')}</p>
      </section>

      <section className={styles.section}>
        <h2>{t('privacy_policy.information_we_collect', 'Information We Collect')}</h2>
        <div>
          <h3>{t('privacy_policy.personal_information_provided', 'Personal Information You Provide')}</h3>
          <p>{t('privacy_policy.personal_information_provided_list', 'We collect information you provide directly to us, such as when you create an account, fill out a form, submit or post content, make a purchase, communicate with us, or otherwise use our services.')}</p>
        </div>
        <div>
          <h3>{t('privacy_policy.information_collected_automatically', 'Information Collected Automatically')}</h3>
          <p>{t('privacy_policy.information_collected_automatically_list', 'When you use our services, we automatically collect certain information, including your IP address, device information, browser type, and cookies. This information is used to maintain security and prevent fraud.')}</p>
        </div>
        <div>
          <h3>{t('privacy_policy.information_from_third_parties', 'Information from Third Parties')}</h3>
          <p>{t('privacy_policy.information_from_third_parties_list', 'We may receive information about you from third parties, such as business partners, data providers, and analytics services.')}</p>
        </div>
      </section>

      <section className={styles.section}>
        <h2>{t('privacy_policy.how_we_use_your_information', 'How We Use Your Information')}</h2>
        <p>{t('privacy_policy.how_we_use_your_information_list', 'We use the information we collect to provide, maintain, and improve our services, process transactions, send communications, protect our services, and comply with legal obligations.')}</p>
      </section>

      <section className={styles.section}>
        <h2>{t('privacy_policy.data_security', 'Data Security')}</h2>
        <p>{t('privacy_policy.data_security_description', 'We implement appropriate security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction.')}</p>
      </section>

      <section className={styles.section}>
        <h2>{t('privacy_policy.your_rights_and_choices', 'Your Rights and Choices')}</h2>
        <p>{t('privacy_policy.your_rights_and_choices_description', 'Depending on your location, you may have certain rights regarding your personal information, such as the right to access, correct, or delete your data.')}</p>
      </section>

      <section className={styles.section}>
        <h2>{t('privacy_policy.contact_us', 'Contact Us')}</h2>
        <p>{t('privacy_policy.contact_us_description', 'If you have any questions about this Privacy Policy, please contact us at privacy@example.com.')}</p>
      </section>
    </div>
  );
};

export default PrivacyPolicyContent;